import React, { useContext } from 'react';

import { ViewerContext } from 'common/containers/ViewerContainer';
import Link from 'common/Link';

type Props = {
  installLink: string;
  installButtonText?: string;
};
const InstallExtensionButton = ({
  installLink,
  installButtonText = 'Install Extension',
}: Props) => {
  const viewer = useContext(ViewerContext);

  if (!viewer || viewer.loggedOut || viewer.companies?.length === 0) {
    // logged out || no companies -> register
    return (
      <Link className="LandingGlobal__cta" to="/register">
        Get started
      </Link>
    );
  }

  // logged in && has company -> admin dashboard (assume first company for now)
  return (
    <a className="LandingGlobal__cta" href={installLink} rel="noopener" target="_blank">
      {installButtonText}
    </a>
  );
};

export default InstallExtensionButton;
